import { Component, Input, OnInit } from "@angular/core";
import {
  InterfaceConfiguration,
  InterfaceCompatibility,
} from "../../../../../codegen/out/types";

@Component({
  selector: "app-interface",
  templateUrl: "./interface.component.html",
  styleUrls: ["./interface.component.scss"],
  standalone: false,
})
export class InterfaceComponent implements OnInit {
  @Input() interfaceConfiguration: InterfaceConfiguration;

  fillColor = "#BDBDBD";

  ngOnInit() {
    if (!this.interfaceConfiguration.enabled) {
      this.fillColor = "#b3b3b3";
    } else {
      switch (this.interfaceConfiguration.interface.compatibility) {
        case InterfaceCompatibility.Compatible:
          this.fillColor = "#43A047";
          break;
        case InterfaceCompatibility.CompatibleWithYellowFlag:
          this.fillColor = "#FDD835";
          break;
        case InterfaceCompatibility.Incompatible:
          this.fillColor = "#D50000";
          break;
      }
    }
  }

  getTooltipLabel(): string {
    if (!this.interfaceConfiguration.enabled) {
      return "Interface is disabled";
    } else {
      switch (this.interfaceConfiguration.interface.compatibility) {
        case InterfaceCompatibility.Compatible:
          return "Interface is compatible";
        case InterfaceCompatibility.CompatibleWithYellowFlag:
          return "Interface has Yellow Flags";
        case InterfaceCompatibility.Incompatible:
          return "Interface is NOT compatible";
      }
    }
  }
}
